<template>
  <div >
    <el-container>
      <el-main>
        <el-row class="flex-centor">
          <el-col hidden-xl-only :xs="24" :sm="15" :md="12" :lg="9" :xl="9">
            <div>
              <el-steps :active="stepActive" finish-status="success">
                <el-step title="Step 1" description="お問い合わせの入力"></el-step>
                <el-step title="Step 2" description="お問い合わせの確認"></el-step>
                <el-step title="Step 3" description="送信完了"></el-step>
              </el-steps>
            </div>
          </el-col>
        </el-row>
        <el-row class="flex-centor">
          <el-col style="width: 1000px;">
            <router-view></router-view>
          </el-col>
        </el-row>
      </el-main>

    </el-container>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";

export default {
  name: "contact",

  computed: {
    //問い合わせナビのためのステップ数値
    stepActive() {
      return this.$store.state.contact.stepActive;
    }
  },
  components: {},
  methods: {}
};
</script>
<style scoped>
.flex-centor {
  display : flex;
  justify-content : center;
}
</style>